export const homeInventoryControl = {
	titleHome: "Inventario",
	buttonCreate: "Crear inventario",
	description:
		"El inventario de existencias tiene un papel muy relevante para el negocio ayudando en el control de las mercancías además de identificar pérdidas y posibles extravíos.",
	mostRecent: {
		titleSection: "Más recientes",
	},
	inventoryHistory: {
		input: {
			search: "Buscar por",
			placeholder: "Título, inventario o almacenista",
		},
		select: {
			filterByPeriod: "Filtrar por período",
			filterByStatus: "Filtrar por estado",
			allStatus: "Todos los estados",
		},
		titleTableColumns: {
			inventoryTitle: "Título del inventario",
			lastEditor: "Último editor",
			lastEdition: "Última edición",
			stockist: "Almacenista",
			stock: "Inventario",
			categories: "Categorías",
			status: "Estado",
			actions: "Acciones",
		},
	},
};
